import React from 'react';
import PropTypes from 'prop-types';
import lessRequire from '../../../../config/less-require-resolver';
import qs from 'qs';
import DownloadPopup from '../popups/download-popup';
import HtmlWarningPopup from '../popups/html-warning';
import TransitLinkPopup from '../popups/transit-link-popup';
import {getPossibleLandingLocations} from '../../functions';

lessRequire('modules/streams/components/download-landing.less');

const isEverad = process.env.CPA_ENV === 'everad';

class DownloadLanding extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isPopupOpen: false,
			isTransitLinkPopupOpen: false,
			landingTargeting: '',
			isOpenHtmlPopup: false,
			is_php: false,
			transitLink: null
		};
		this.togglePopup = this.togglePopup.bind(this);
		this.toggleTransitPopup = this.toggleTransitPopup.bind(this);
		this.setTransitLinkUrl = this.setTransitLinkUrl.bind(this);
		this.closePopup = this.closePopup.bind(this);
		this.closeHtmlPopup = this.closeHtmlPopup.bind(this);
		this.setLandingTargeting = this.setLandingTargeting.bind(this);
	}
	togglePopup(e, href, is_php = false) {
		e && e.preventDefault();
		this.setState(state => ({
			isPopupOpen: !state.isPopupOpen,
			popupHref: href,
			isPhpPopup: is_php
		}));
	}
	toggleTransitPopup(e, is_php = false) {
		e && e.preventDefault();
		this.setState((state) =>
			({ isTransitLinkPopupOpen: !state.isTransitLinkPopupOpen, is_php })
		);
	}
	setTransitLinkUrl(url) {
		this.setState((state) => ({ transitLink: url }));
	}
	setLandingTargeting(country_code) {
		this.setState((state) => ({ landingTargeting: country_code }));
	}
	closePopup() {
		this.setState((state) => ({ isTransitLinkPopupOpen: false }));
	}

	closeHtmlPopup() {
		this.setState((state) => ({ isOpenHtmlPopup: false }));
	}

	render() {
		const {
			domain,
			streamId,
			intl,
			language,
			landing_id,
			isEditMode,
			type,
			offerGeoStats,
			campaignCountryCode
		} = this.props;
		const query = {campaign_id: streamId || '', lang: language, landing_id};
		const possibleLocations = getPossibleLandingLocations(
			language,
			offerGeoStats && offerGeoStats.rows,
			campaignCountryCode
		);
		if (type === 'transit' && this.state.transitLink) {
			query.transit_link = this.state.transitLink;
		}
		if (possibleLocations && possibleLocations.length === 1) {
			query.country_code = possibleLocations[0].value;
		}
		if (this.state.landingTargeting) {
			query.country_code = this.state.landingTargeting;
		}

		const requestUrl = `/v2/campaigns/offer-domains/${domain}/download?${qs.stringify(query)}`;

		const downloadLinkProps = {className: 'landing-download', href: requestUrl };
		const downloadLinkPhpProps = {...downloadLinkProps, href: downloadLinkProps.href + '&is_php=true'};

		if (type === 'landing' && (!isEditMode || possibleLocations.length > 1)) {
			downloadLinkProps.onClick = (e) => {
				this.togglePopup.call(this, e, downloadLinkProps.href, false);
			};

			downloadLinkPhpProps.onClick = (e) => {
				this.togglePopup.call(this, e, downloadLinkPhpProps.href, true);
			};
		}
		if (type === 'transit') {
			downloadLinkProps.onClick = (e) => {
				this.toggleTransitPopup(e, false);
			};

			downloadLinkPhpProps.onClick = (e) => {
				this.toggleTransitPopup(e, true);
			};
		}

		if (isEverad && type === 'landing') {
			downloadLinkProps.onClick = (e) => {
				e.preventDefault();
				this.setState(() => ({ isOpenHtmlPopup: true }));
			};
		}
		return (!isEverad || isEditMode) && (
			<span>
				<a {...downloadLinkPhpProps}>
					<span className="download-text">{`${intl('Скачать')} `}</span>
					<i className="icon-download"/>
					<span className="download-text">{intl('php')}</span>
				</a>
				<a {...downloadLinkProps}>
					<i className="icon-download download-html"/>
					<span className="download-text">{intl('html')}</span>
				</a>
				<DownloadPopup
					isOpen={this.state.isPopupOpen}
					intl={intl}
					togglePopup={this.togglePopup}
					href={this.state.popupHref}
					isEditMode={isEditMode}
					setLandingTargeting={this.setLandingTargeting}
					landingTargeting={this.state.landingTargeting}
					requestUrl={requestUrl}
					possibleLocations={possibleLocations}
					isPhpPopup={!!this.state.isPhpPopup}
				/>
				<HtmlWarningPopup
					isOpen={this.state.isOpenHtmlPopup}
					intl={intl}
					closeHtmlPopup={this.closeHtmlPopup}
					htmlHref={downloadLinkProps.href}
					phpHref={downloadLinkPhpProps.href}
				/>
				<TransitLinkPopup
					isOpen={this.state.isTransitLinkPopupOpen}
					intl={intl}
					href={requestUrl}
					togglePopup={this.toggleTransitPopup}
					setTransitLinkUrl={this.setTransitLinkUrl}
					closePopup={this.closePopup}
					is_php={this.state.is_php}
				/>
			</span>
		);
	}
}

DownloadLanding.propTypes = {
	domain: PropTypes.string,
	isEditMode: PropTypes.bool,
	language: PropTypes.string,
	landing_id: PropTypes.number,
	streamId: PropTypes.string,
	intl: PropTypes.func,
	type: PropTypes.string
};

export default DownloadLanding;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/display-type/download-landing.js